module.exports = __webpack_public_path__ + "img/horizontal_6_4_9005.b27f1e72.png";